<script setup lang="ts">
import Banner from "@/components/shared/Banner.vue"

const pathname = window.location.pathname
const showBanner =
  !pathname.includes("benchmarking") && !pathname.includes("dashboard")

const year = new Date().getFullYear()
</script>

<template>
  <Banner
    v-if="showBanner"
    :id="`xy-${year}-survey-banner`"
    link="/benchmarking"
    :hide-duration="7"
    btn-text="Fill It Out"
  >
    <span class="font-semibold">Benchmarking Survey {{ year }}</span>
    <svg
      viewBox="0 0 2 2"
      class="mx-2 inline h-1 w-1 fill-current"
      aria-hidden="true"
    >
      <circle cx="1" cy="1" r="1" /></svg
    >Submit your survey now!
  </Banner>
</template>
